export default "__VITE_ASSET__B1SDSqN7__"